import type { ClientId } from './clients';

export type Project = {
  id: string;
  title: string;
  description: string;
  client: ClientId;
  clientName: string;
  review: string;
  reviewer: string;
  reviewUrl: string;
  downloadUrl: string;
  rating: number;
  details: string[];
  authorName: string;
  /** Profile picture URL. Leave empty to show an initial like an account without a photo. */
  avatar: string;
};

// PLACEHOLDERS: only the Haertl quote is real (from konradwalz.com). Reviewer names, photos, ratings,
// details and links are invented and must be replaced with real, consented reviewer data before launch.
export const projects: Project[] = [
  {
    id: 'haertl-baugruppen',
    title: 'Baugruppen Sondermaschinenbau',
    description: 'Unterbaugruppen und Einzelteilzeichnungen nach Kundenstandard – fertigungsreif in 2 Wochen.',
    client: 'haertel',
    clientName: 'Härtel',
    review:
      'Herr Walz hat unsere Engpässe in der Baugruppenkonstruktion innerhalb von 2 Wochen perfekt aufgefangen. Absolut präzise Fertigungsdaten!',
    reviewer: 'Sondermaschinenbau',
    reviewUrl: '#',
    downloadUrl: '#',
    rating: 5,
    details: ['2 Wochen', 'Baugruppenkonstruktion', 'ca. 4.800 €'],
    authorName: 'Thomas Bauer',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/127d0dda-9f2b-443d-b40e-d101eb8a418f.jpg',
  },
  {
    id: 'vortriebsmodul',
    title: 'Vortriebsmodul',
    description: 'Komplette Patentanmeldung, modelliert in Inventor – mit Funktionsanimation in Blender.',
    client: 'holzwerkstatt',
    clientName: 'Holzwerkstatt DH',
    review:
      'Aus unseren Skizzen und dem Prototyp wurde ein sauberes Patentmodell. Die Animation hat beim Patentamt jede Frage beantwortet.',
    reviewer: 'Geschäftsführung',
    reviewUrl: '#',
    downloadUrl: '#',
    rating: 5,
    details: ['6 Wochen', 'Patentmodell & Animation', 'ca. 7.500 €'],
    authorName: 'Dieter H.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/9644deab-bb4e-48a0-b32a-3652823af51f.jpg',
  },
  {
    id: 'parallelgreifer',
    title: 'Pneumatischer Parallelgreifer',
    description: 'Kompakter Greifer mit Wechselbacken für eine enge Handhabungszelle.',
    client: 'sycotec',
    clientName: 'SycoTec',
    review: 'Passte auf Anhieb in den Bauraum. Die Backen tauschen wir heute in unter einer Minute.',
    reviewer: 'Leitung Automation',
    reviewUrl: '#',
    downloadUrl: '#',
    rating: 5,
    details: ['3 Wochen', 'Konstruktion Automation', 'ca. 3.200 €'],
    authorName: 'Markus Lehner',
    avatar: '',
  },
  {
    id: 'schaltschrank',
    title: 'Blechgehäuse Schaltschrank',
    description: 'Gekantetes Gehäuse inklusive DXF-Abwicklungen für den Laserzuschnitt.',
    client: 'nordictrail',
    clientName: 'Nordictrail',
    review: 'Unser Fertiger konnte die Abwicklungen ohne eine einzige Rückfrage umsetzen.',
    reviewer: 'Produktentwicklung',
    reviewUrl: '#',
    downloadUrl: '#',
    rating: 5,
    details: ['1 Woche', 'Blechkonstruktion', 'ca. 1.400 €'],
    authorName: 'Julia Sommer',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/4b622ae5-8412-48ec-a46f-6285854ca60d.jpg',
  },
];
